export default __webpack_public_path__ + "static/media/event4.9a5e1ddd.png";